import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderPosition} from "../../../shared/models/OrderPosition";
import {Order} from "../../../shared/models/Order";
import {OrderService} from "../../../core/http/order.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-received-orders-details-popup',
  templateUrl: './received-orders-details-popup.component.html',
  styleUrls: ['./received-orders-details-popup.component.scss']
})
export class ReceivedOrdersDetailsPopupComponent {
  positions: OrderPosition[]; // Property to store the positions data
  displayedColumns: string[] = ['name', 'itemPrice', 'quantity', 'cancelledQuantityRequested', 'cancelledQuantityAccepted', 'total', 'cancelPosition'];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private orderService: OrderService,
              private _snackBar: MatSnackBar,
              public dialogRef: MatDialogRef<ReceivedOrdersDetailsPopupComponent>) {
    this.positions = data.positions; // Get the positions data from the injected data
  }

  cancelPosition(orderPosition: OrderPosition) {
    this.orderService.markOrderPositionAsCancelled(orderPosition.guid).subscribe({
      next: (response) => {
        console.log('send cancel order position');
        this._snackBar.open('Position ' + orderPosition.name + ' 1x storniert', 'Schließen', {duration: 3000});
        this.dialogRef.close(true);
      },
      error: (error) => {
        this._snackBar.open('Beim Stornieren der Position ' + orderPosition.name + ' ist ein Fehler aufgetreten', 'Schließen', {duration: 3000});
        console.error(error);
      }
    });
  }
}
